import { FC, forwardRef, ReactNode } from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Dialog, DialogTitle, Grow, Typography } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";

type Props = {
	open: boolean;
	width: string | number | null;
	titleIcon?: IconProp | null;
	title?: string;
	body?: ReactNode;
	onClose?: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void;
	showTitle?: boolean;
};

const Transition = forwardRef(function Transition(
	props: TransitionProps & {
		children: React.ReactElement<any, any>;
	},
	ref: React.Ref<unknown>
) {
	return <Grow ref={ref} {...props} />
});

const ModalDialog: FC<Props> = ({ open, width, titleIcon, title, body, onClose, showTitle }) => {
	if (showTitle === undefined) {
		showTitle = true;
	}

	return (
		<Dialog
			open={open}
			onClose={onClose}
			TransitionComponent={Transition}
			PaperProps={{ elevation: 2, sx: { width: width, maxWidth: width } }}
			slotProps={{
				backdrop: {
					style: {
						backdropFilter: 'blur(6px) saturate(2)'
					}
				}
			}}
		>
			{showTitle && (
				<DialogTitle sx={{ display: 'flex', alignItems: 'center', p: [1, 2] }}>
					{titleIcon && (
						<FontAwesomeIcon icon={titleIcon} style={{ marginRight: 8 }} />
					)}
					<Typography sx={{ fontSize: 20 }}>{title}</Typography>
				</DialogTitle>
			)}
			<Box>
				{body}
			</Box>
		</Dialog>
	);
};

export default ModalDialog;
